module.exports = __webpack_public_path__ + "media/images/orion_pictos/tick-e81534b6d0c50447a377f2c190ee56ec.svg";